import React from 'react';

const highlightSearchTerm = (text: string, searchTerm: string): JSX.Element => {
    if (!searchTerm.trim()) {
        return <span>{text}</span>;
    }
    const parts = text?.split(new RegExp(`(${searchTerm})`, 'gi'));

    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === searchTerm.toLowerCase() ? (
                    <span key={index} className='lxs-create-order__highlight-search-term'>
                        {part}
                    </span>
                ) : (
                    part
                )
            )}
        </span>
    );
};

export default highlightSearchTerm;
